import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import FAQ_API from 'api/faq/v1'
import { selectAppLocale } from 'modules/App/store/selectors'
import { mapCategoriesToNavItems } from 'modules/Faq/utils/mapCategoriesToNavItems'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import findMatchedRoutes from 'utils/findMatchedRoutes'
import { ensureRouteModulesLoaded } from 'store/domains/utils'
import { useNotifications } from 'modules/Notifications/hooks/useNotifications'

const initialState = {
  items: [],
  loading: false,
  failed: false,
}

export const useFaqNavItems = (enabled = false) => {
  const { pathname } = useLocation()
  const locale = useSelector(selectAppLocale)
  const pathGen = useGeneratePathI18n()
  const { notificationShow } = useNotifications()
  const [state, setState] = useState(initialState)

  useEffect(() => {
    if (!enabled || !locale) {
      if (!enabled) {
        setState(initialState)
      }
      return
    }

    let canceled = false

    const load = async () => {
      setState((prev) => ({ ...prev, loading: true, failed: false }))

      const activeRoute = findMatchedRoutes(undefined, pathname).at(-1)
      await ensureRouteModulesLoaded(pathname, activeRoute?.key)

      if (canceled) {
        return
      }

      try {
        const { response, error } = await FAQ_API.fetchCategoriesTree({
          params: { lang: locale },
        })

        if (canceled) {
          return
        }

        if (error) {
          throw error
        }

        setState({
          items: mapCategoriesToNavItems(response.data, pathGen),
          loading: false,
          failed: false,
        })
      } catch {
        if (canceled) {
          return
        }

        notificationShow({
          type: 'error',
          message: 'common::notifications.data_fetch_failed',
        })
        setState({ items: [], loading: false, failed: true })
      }
    }

    load()

    return () => {
      canceled = true
    }
    // pathname нужен только для ensureRouteModulesLoaded при первой загрузке
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, locale])

  return state
}
